import { useActiveAccount } from "thirdweb/react";
import { getUserEmail } from "thirdweb/wallets/in-app";
import { client } from "../constants/client";
import { useProfileQuery } from "../services/userService";
import { useEffect, useState } from "react";
import { ACCESS_TOKEN_NAME } from "../constants";

export const useLoginStatus = () => {
    if (localStorage.getItem(ACCESS_TOKEN_NAME)) {
        return true;
    }
    return false;
};

export const useProfile = () => {
    const { data: profileData } = useProfileQuery();
    const user = profileData?.data || null;

    const activeAccount = useActiveAccount();
    const [walletEmail, setWalletEmail] = useState(undefined);

    useEffect(() => {
        async function fetchEmail() {
            const email = await getUserEmail({ client });
            setWalletEmail(email);
        }
        fetchEmail();
    }, []);

    const getUser = () => user;

    return {
        user,
        wallet: activeAccount,
        walletEmail,
        getUser,
    };
};
